import { useRef } from 'react';
import type { GridSize } from 'types/capi/plp';

import ArrowIcon from '~/assets/icons/Arrow';
import useHasScrolledIntoView from '~/hooks/useHasScrolledIntoView';

import { cardWidths } from './Products';

export default function NotificationTooltip({
  gridSize
}: {
  gridSize: GridSize;
}) {
  const tooltipRef = useRef<HTMLDivElement>(null);
  const hasScrolledIntoView = useHasScrolledIntoView(tooltipRef);

  return (
    <div
      ref={tooltipRef}
      className={
        gridSize === 'large'
          ? `${cardWidths.large} max-md:hidden`
          : cardWidths.small
      }
    >
      {hasScrolledIntoView && (
        <div className="flex min-h-8 animate-slide-delay items-center justify-between gap-1 bg-white/90 bg-[linear-gradient(0deg,_rgba(209,_159,_244,_0.16)_0%,_rgba(209,_159,_244,_0.16)_100%)] px-2 py-1.5 opacity-0 md:pr-4">
          <div className="text-xs leading-5 text-purple-hola">
            Tap the bell to get a release alert
          </div>
          <div className="rotate-270">
            <ArrowIcon fill="#8907e7" className="animate-pulse" />
          </div>
        </div>
      )}
    </div>
  );
}
